export const introduce = {
  text: '每秒可以执行的哈希运算次数。',
  height: 1200,
};
